export const cliName = 'papra';
